import { FavoritesAssignWidgetContainer } from '@cian/favorites-assign-widget';
import { useDispatch, useSelector } from 'react-redux';

import { FavoritesFolders } from 'shared/components/FavoritesFolders';
import { selectIsAuthenticated } from 'shared/slices';
import { EAlertType, requestAuthentication } from 'shared/thunks/auth';
import { TThunkDispatch } from 'shared/types/redux';

export function FavoritesFoldersContainer() {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const dispatch: TThunkDispatch = useDispatch();

  const handleLogin = () => {
    dispatch(requestAuthentication({ alert: EAlertType.Favorites }));
  };

  // onCreateFolder, onSaveOffer, onClickFolderName, onNotificationSaveToFolder, onNotificationChangeFolder - нужны для аналитики

  return (
    <FavoritesFolders>
      <FavoritesAssignWidgetContainer
        isAuthenticated={isAuthenticated}
        disableNotification={true}
        // onCreateFolder={handleCreate}
        // onSaveOffer={handleSave}
        onWaitForLogin={handleLogin}
        // onClickFolderName={handleClickFolderName}
        // onNotificationSaveToFolder={handleSaveToFolder}
        // onNotificationChangeFolder={handleChangeFolder}
      />
    </FavoritesFolders>
  );
}
